import * as apiTo from '@api/api-routes'
import { cloneDeep } from 'lodash'

export default {
  namespaced: true,

  state: {
    savedReports: null,
    reportToEdit: null,
    reportToView: null,
    reportTypes: null,
    newReport: null,
    activeToolbar: 'savedReports', // can be savedReports or reportColumns,
    showBuildingReportBtn: false,
    showReportColumns: false,
    visibleColumns: null,
    routerView: 'startingPage',
    isReportUpdated: false
  },

  getters: {
    isReportUpdated(state) {
      return JSON.stringify(state.reportToEdit) !== JSON.stringify(state.reportToView) || state.isReportUpdated
    }
  },

  mutations: {
    setSavedReports: (state, payload) => (state.savedReports = payload),
    addSavedReport(state, payload) {
      state.savedReports.unshift(payload)
    },
    updateSavedReport(state, payload) {
      const index = state.savedReports.findIndex(report => report.id === payload.id)
      if (~index) state.savedReports.splice(index, 1, payload)
      state.reportToEdit = cloneDeep(payload)
      state.reportToView = cloneDeep(payload)
      state.isReportUpdated = false
    },
    setReportToEdit: (state, payload) => (state.reportToEdit = payload),
    setReportToView: (state, payload) => (state.reportToView = payload),
    setReportTypes: (state, payload) => (state.reportTypes = payload),
    setNewReport: (state, payload) => {
      state.newReport = payload
      state.activeToolbar = 'reportColumns'
    },
    updateNewReport: (state, payload) => (state.newReport = payload),
    setActiveToolbar: (state, payload) => (state.activeToolbar = payload),
    setShowBuildingReportBtn: (state, payload) => (state.showBuildingReportBtn = payload),
    setShowReportColumns: (state, payload) => (state.showReportColumns = payload),
    setVisibleColumns: (state, payload) => (state.visibleColumns = payload),
    reportDeleted(state, id) {
      state.savedReports = state.savedReports.filter(report => report.id !== id)
    },
    setRouterView: (state, payload) => (state.routerView = payload),
    setIsReportUpdated: (state, payload) => (state.isReportUpdated = payload)
  },

  actions: {
    getReportTypesAndSavedReports({ commit }) {
      return Promise.all([apiTo.getReportTypes(), apiTo.getReports()]).then(
        ([{ data: reportTypes }, { data: savedReports }]) => {
          commit('setReportTypes', reportTypes.result)
          commit('setSavedReports', savedReports.result)
        }
      )
    },

    viewReport({ commit }, report) {
      const clonedReport = cloneDeep(report)
      commit('setActiveToolbar', 'reportColumns')
      commit('setReportToEdit', clonedReport)
      commit('setReportToView', clonedReport)
    }
  }
}
